exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".answer-choice-view-container {\n  margin-bottom: 1em;\n  padding: 20px;\n  min-height: 124px; }\n  .answer-choice-view-container.hidden-answer {\n    background-color: #bac1c6; }\n\n.btn_toggle {\n  background-color: #79a1bb;\n  display: inline-block;\n  font-weight: bold;\n  padding: 0.7em 0.7em;\n  margin: 0;\n  min-width: 145px;\n  color: #ffffff;\n  border-radius: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/@mprep/shared/lib/angular/components/question-view/choice-views/hide-show-choice-view/hide-show-question-view.scss
// module id = k8SG
// module chunks = 3